<template>
  <div class='childrens_mvp'>
    <div class="head">
      <div class='fold-btns'>
        <a-button size='small' @click='fold(1)' v-show='!foldShow'>折叠功能详细</a-button>
        <a-button size='small' @click='fold(0)' v-show='foldShow'>展开功能详细</a-button>
        <!-- <a-icon type="caret-right" @click='fold(1)' v-show='!foldShow'/>
        <a-icon type="caret-left" @click='fold(0)' v-show='foldShow'/> -->
      </div>
    </div>
    <div v-if='childrensItem._id' class="cont" ref='cont'>
      <div v-show="childrensItem.level === 2" class="scroll">
        <model :edit='edit' :data='data.model' :open='data.modelFold'></model>
        <process :edit='edit' :data='data.process' :open='data.processFold' :view='data.view'></process>
        <views :edit='edit' :data='data.view' :open='data.viewFold' :model='data.model'></views>
      </div>
      <div class="spin" v-show='spin'>
        <a-spin size='large' />
      </div>
    </div>
    <a-empty class='empty' v-else description='暂时没有数据'></a-empty>
    <modelModal :model='data.model' :childrensItem='childrensItem' ref='modelModal'></modelModal>
  </div>
</template>

<script>
import model from './model'
import views from './views'
import process from './process'
import modelModal from './components/modelModal'
import set from './settings/settings.js'
import { mapState } from 'vuex'

export default {
  components: {
    model,
    views,
    process,
    modelModal
  },
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    childrensItem: {
      type: Object
    },
    foldShow: {
      type: Boolean
    },
    foldType: {
      type: Number
    }
  },
  data () {
    return {
      data: {},
      spin: true
    }
  },
  computed: {
    ...mapState('editor', ['user'])
  },
  watch: {
    childrensItem (n) {
      if (n._id && n.level === 2) {
        this.spin = true
        let appId = ''
        if (this.foldType === 0) {
          appId = n.app_id
        } else {
          appId = this.$route.query.app_id
        }
        this.$post('/wuwei/api/func/getMVP', { app_id: appId, function_id: n._id }).then(result => {
          Object.keys(set).map(item => {
            result[set[item].fold] = set[item].default
          })
          this.data = result
          this.spin = false
        }).catch(res => {
          console.warn(res)
          this.spin = false
        })
      } else {
        this.data = {}
      }
    }
  },
  methods: {
    initData () {
      this.spin = true
      this.childrensItem._id ? this.$post('/wuwei/api/func/getMVP', { app_id: this.$route.query.app_id, function_id: this.childrensItem._id }).then(result => {
        Object.keys(set).map(item => {
          result[set[item].fold] = set[item].default
        })
        this.data = result
        this.spin = false
      }).catch(res => {
        console.warn(res)
        this.spin = false
      })
        : this.spin = false
    },
    fold (type) {
      this.$emit('foldChange', type)
    },
    focusId (tarid) {
      this.$nextTick(() => {
        let dom = document.querySelector(`#x${tarid}`)
        if (dom && dom.focus) {
          dom.focus()
        }
      })
    },
    findName (list, str) {
      for (let i = 1; i < list.length + 2; i++) {
        if (!list.find(item => item.name === str + i)) {
          return str + i
        }
      }
    }
  },
  mounted () {
    const editorUrl = this.$paths.editor
    // item组件的操作
    this.$event.$on('initMVPData', () => {
      this.initData()
    })
    this.$event.$on('childrensAdd', (item, type, level, levelOne) => {
      // 点击添加的方法
      let data = {
        function_id: this.childrensItem._id,
        app_id: this.$route.query.app_id,
        project_id: this.$route.query.project_id
      }
      switch (item) {
        case 'model':
          // 新增数据库表
          this.sendLogger({
            action: 'post',
            type: 'table',
            func_id: this.childrensItem._id
          })
          this.$refs.modelModal.show('model', 1)
          break
        case 'process':
          // 新增流程图
          this.sendLogger({
            action: 'post',
            type: 'flow',
            func_id: this.childrensItem._id
          })
          let name = this.findName(this.data.process, '1级新增流程')
          Object.assign(data, {
            name
          })
          this.$post('/wuwei/api/process/create', data).then(result => {
            result.result.pageSelectShow = true
            this.data.process.push(result.result)
            this.$set(this.data, 'processFold', true)
            this.focusId(result.result._id)
          })
          break
        default:
          switch (type) {
            case 'model':
            // 新增数据库字段
              this.sendLogger({
                action: 'post',
                type: 'table',
                func_id: this.childrensItem._id,
                type_id: item.table_id,
                node_id: item._id
              })
              this.$refs.modelModal.show('field', 2, levelOne)
              break
            case 'process':
              // 增加流程节点
              this.sendLogger({
                action: 'post',
                type: 'flow',
                func_id: this.childrensItem._id,
                type_id: item.flow_id,
                node_id: item._id
              })
              let name = this.findName(item.children, (level + 1) + '级新增流程')
              Object.assign(data, {
                name,
                _id: item._id
              })
              this.$post('/wuwei/api/process/create', data).then(result => {
                if (!item.children) {
                  this.$set(item, 'children', [])
                }
                result.result.pageSelectShow = true
                item.children.push(result.result)
                this.$set(item, 'open', true)
                this.focusId(result.result._id)
              })
              break
            case 'view':
              if (level === 1) {
                Object.assign(data, {
                  page_type: item.type,
                  name: '新建页面',
                  type: 0,
                  layoutType: 0
                })
                this.$post('/wuwei/api/page/create', data).then(result => {
                  // 新增页面
                  this.sendLogger({
                    action: 'post',
                    type: 'page',
                    func_id: this.childrensItem._id,
                    page_id: result.data._id
                  })
                  if (!item.children) {
                    this.$set(item, 'children', [])
                  }
                  result.data.tableSelectShow = true
                  item.children.push(result.data)
                  this.$set(item, 'open', true)
                  this.focusId(result.data._id)
                  this.$nextTick(() => {
                    const dom = document.querySelector('.tableSelect')
                    dom && dom.scrollIntoView && dom.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'end' })
                  })
                })
              } else if (level === 3) {
                // Object.assign(data, {
                //   type: item.type,
                //   name: '新建控件',
                //   view_id: item.view_id
                // })
                // console.log('点击新建控件')
                // 创建控件
              }
              break
          }
      }
    })
    this.$event.$on('childrensPreview', (item, type) => {
      if (this.user.temporary) {
        this.$event.$emit('logIn')
        return
      }
      // 点击预览的方法,item是页面的信息,预览目前只有页面有,所以type没用
      this.$put('/api/app/preview', {
        app_id: this.$route.query.app_id,
        project_id: this.$route.query.project_id,
        page_id: item.page_id,
        secureStatic: false
      }).then(({ url }) => {
        if (url) {
          this.$open(url, '_blank', '')
        }
      })
    })
    this.$event.$on('childrensSetting', (item, type, level, levelOne) => {
      if (this.user.temporary) {
        this.$event.$emit('logIn')
        return
      }
      // 点击设置的方法,type是model的时候打开弹窗,其它的时候调用接口
      if (type === 'model') {
        this.$refs.modelModal.show(item, level, levelOne)
      } else if (type === 'process') {
        // TODO:item是页面或者流程的信息
        let tar = `${editorUrl}/${this.$route.query.app_id}/flow/${item._id}/flow_id/${item._id}?function_id=${this.childrensItem._id}`
        if (item.page_id) {
          tar += `&page_id=${item.page_id}`
        }
        this.$post('/wuwei/api/commercializationLogs', {
          events: '点击',
          types: '对标页编辑器按钮'
        })
        this.$open(tar, '_blank', '')
        // console.log('流程调用设置接口', item)
      } else {
        if (level === 2) {
          this.$post('/wuwei/api/commercializationLogs', {
            events: '点击',
            types: '对标页编辑器按钮'
          })
          // console.log('页面调用设置接口', item, level, editorUrl)
          this.$open(`${editorUrl}/${this.$route.query.app_id}/panel/${item.page_id}?project_id=${this.$route.query.project_id}&function_id=${this.childrensItem._id}`, '_blank', '')
        } else if (level === 4) {
          this.$post('/wuwei/api/commercializationLogs', {
            events: '点击',
            types: '对标页编辑器按钮'
          })
          // console.log('控件调用设置接口', item, level)
          this.$open(`${editorUrl}/${this.$route.query.app_id}/panel/${item.page_id}?project_id=${this.$route.query.project_id}&function_id=${this.childrensItem._id}`, '_blank', '')
          // editor2.x不支持url选控件， url打开弹窗
        } else if (level === 6) {
          // console.log('事件调用设置接口', item, level)
          this.$open(`${editorUrl}/${this.$route.query.app_id}/flow/${item.page_id}/flow_id/${item._id}?project_id=${this.$route.query.project_id}&function_id=${this.childrensItem._id}`, '_blank', '')
        }
      }
    })
    this.$event.$on('childrensClose', (item, type, level, list) => {
      let data = {
        function_id: this.childrensItem._id,
        app_id: this.$route.query.app_id,
        project_id: this.$route.query.project_id
      }
      const remove = () => {
        let idx = list.findIndex(items => items._id === item._id)
        list.splice(idx, 1)
      }
      switch (type) {
        case 'process':
          // 删除流程节点以及流程图
          this.sendLogger({
            action: 'delete',
            type: 'flow',
            func_id: this.childrensItem._id,
            type_id: item.flow_id,
            node_id: item._id
          })
          Object.assign(data, {
            _id: item._id
          })
          this.$post('/wuwei/api/process/delete', data).then(result => {
            remove()
          })
          break
        case 'view':
          // 删除页面
          this.sendLogger({
            action: 'delete',
            type: 'page',
            func_id: this.childrensItem._id,
            page_id: item._id,
            type_id: item._id
          })
          switch (level) {
            case 2:
              Object.assign(data, {
                page_id: item._id
              })
              this.$post('/wuwei/api/page/delete', data).then(result => {
                remove()
              })
              break
          }
          break
      }
    })
    this.$event.$on('childrensChangeName', (item, type, level) => {
      // 更改名称的接口,model处理的,不需要处理数据
      let data = {
        function_id: this.childrensItem._id,
        app_id: this.$route.query.app_id,
        project_id: this.$route.query.project_id
      }
      switch (type) {
        case 'process':
        // 编辑流程图以及流程节点id
          this.sendLogger({
            action: 'put',
            type: 'flow',
            func_id: this.childrensItem._id,
            type_id: item.flow_id,
            node_id: item._id
          })
          Object.assign(data, {
            _id: item._id,
            name: item.name
          })
          this.$post('/wuwei/api/process/update', data).then(result => {})
          break
        case 'view':
          // 编辑页面
          this.sendLogger({
            action: 'put',
            type: 'page',
            func_id: this.childrensItem._id,
            page_id: item._id,
            type_id: item._id
          })
          switch (level) {
            case 2:
              Object.assign(data, {
                page_id: item._id,
                name: item.name
              })
              this.$post('/wuwei/api/page/modify', data).then(result => {})
              break
          }
          break
      }
    })
    this.$event.$on('changeOpen', (item) => {
      // mvp类型展开折叠的方法
      this.$set(this.data, set[item].fold, !this.data[set[item].fold])
    })
    this.$event.$on('childrensChangeOpen', (item, type) => {
      // 更改展开折叠状态,不需要调用接口,这里在前进后退之后会被触发两次,目前找不到原因,暂时用防抖处理
      this.$set(item, 'open', !type)
    })
    this.$event.$on('scrollTo0', (item, type) => {
      // this.$nextTick(() => {
      //   if (this.$refs.cont.scrollTo) {
      //     this.$refs.cont.scrollTo(0, 0)
      //   }
      // })
    })
    this.$event.$on('changeModel', (data) => {
      this.$set(this.data, 'model', data)
    })
    this.$event.$on('pageBindTable', (list, idx, table) => {
      const item = list[idx]
      let data = { page_id: item._id,
        name: item.name,
        table_id: table.table_id,
        function_id: this.childrensItem._id,
        app_id: this.$route.query.app_id,
        project_id: this.$route.query.project_id }
      this.$post('/wuwei/api/page/modify', data).then(result => {
        this.$set(list, idx, result.data)
        this.$message.success('绑定成功')
      })
    })
    this.$event.$on('processBindPage', (data, item) => {
      // data,流程数据,item 页面数据
      const datas = {
        page_id: item.page_id,
        flow_id: data._id,
        app_id: this.$route.query.app_id,
        project_id: this.$route.query.project_id
      }
      this.$post('/api/flow/bindPage', datas).then(result => {
        this.$message.success('绑定成功')
      })
    })

    this.$nextTick(() => {
      // 拖动的事件
      const doc = document.querySelector('.childrens_mvp')
      let x1 = 0
      let x2 = 0
      let y1 = 0
      let y2 = 0
      let x0 = 0
      let y0 = 0
      doc.onmousedown = ev => {
        let event = ev || window.event
        if (event.path[0].className !== 'text') {
          x1 = event.pageX
          y1 = event.pageY
          x0 = this.$refs.cont.scrollLeft
          y0 = this.$refs.cont.scrollTop
          document.body.style.cursor = '-webkit-grab'
          window.onmousemove = ev2 => {
            let event2 = ev2 || window.event
            x2 = event2.pageX
            y2 = event2.pageY
            this.$refs.cont.scrollTo(x0 + x1 - x2, y0 + y1 - y2)
            document.body.style.cursor = '-webkit-grabbing'
          }
        }
      }
      window.onmouseup = (ev) => {
        window.onmousemove = null
        document.body.style.cursor = 'default'
      }
      this.spin = false
    })
    window.addEventListener('message', e => {
      if (typeof (e.data) !== 'string') {
        return
      }
      const data = JSON.parse(e.data)
      console.log(data)
      switch (data.type) {
        case 'page':
          if (this.data && this.data.view && this.data.view.length) {
            let type = this.data.view.find(item => item.type === data.from)
            if (type && type.children && type.children.length) {
              let page = type.children.find(item => item.page_id === data.data._id)
              if (!page) break
              page.name = data.data.name
              this.$set(this.data, 'viewFold', true)
              if (data.from !== data.data.type) {
                page.components = data.data.components
                let idx = type.children.findIndex(item => item.page_id === data.data._id)
                let tar = this.data.view.find(items => items.type === data.data.type)
                type.children.splice(idx, 1)
                tar.children.push(page)
                this.$set(tar, 'open', true)
              } else {
                this.$set(type, 'open', true)
              }
            }
          }
          this.$forceUpdate()
          break
        case 'pageRemove':
          let types = this.data.view.find(item => item.type === data.from)
          let idxs = types.children.findIndex(item => item.page_id === data._id)
          if (idxs !== -1) {
            types.children.splice(idxs, 1)
          }
          break
        case 'components':
          if (this.data && this.data.view && this.data.view.length) {
            let type3 = this.data.view.find(item => item.type === data.from)
            if (type3 && type3.children && type3.children.length) {
              let page3 = type3.children.find(item => item.page_id === data.data._id)
              data.data.components.map(item => {
                item.open = true
              })
              if (page3 && page3.components) {
                page3.components = data.data.components
              }
              this.$set(type3, 'open', true)
              this.$set(page3, 'open', true)
              this.$set(this.data, 'viewFold', true)
            }
          }
          break
        case 'process':
          // let process = data.data.filter(item => item.function_id === this.childrensItem._id)
          let process = data.data
          const change = (arr) => {
            arr.map(item => {
              item.open = true
              if (item.children) {
                change(item.children)
              }
            })
          }
          if (Array.isArray(process)) {
            change(process)
            this.$set(this.data, 'processFold', true)
            this.$set(this.data, 'process', process)
          }
          break
        case 'processChangeModel':
          // const processChangeModel = data.data.find(item => item.function_id === this.childrensItem._id).model
          // this.$set(this.data, 'model', processChangeModel)
          this.$set(this.data, 'model', data.data)
          this.$set(this.data, 'modelFold', true)
          break
        case 'addTable':
          // 暂时不能创建
          // this.data.model.push(data.data)
          break
        case 'changeTable':
          let model = this.data.model.find(item => item._id === data.data._id)
          if (model) {
            if (data.data) {
              Object.assign(model, data.data)
            }
            this.$set(model, 'open', true)
            this.$set(this.data, 'modelFold', true)
          }
          break
        case 'deleteTable':
          let idx = this.data.model.findIndex(item => item._id === data.data._id)
          if (idx !== -1) {
            this.data.model.splice(idx, 1)
          }
          break
        case 'processRemove':
          const del = (arr, id) => {
            let idx = arr.findIndex(item => item._id === id)
            if (idx !== -1) {
              arr.splice(idx, 1)
            } else {
              arr.map(item => {
                if (item.children) {
                  del(item.children, id)
                }
              })
            }
          }
          del(this.data.process, data.data.id)
          break
      }
    })
  },
  beforeDestroy () {
    this.$event.$off('childrensAdd')
    this.$event.$off('childrensPreview')
    this.$event.$off('childrensSetting')
    this.$event.$off('childrensClose')
    this.$event.$off('childrensChangeName')
    this.$event.$off('changeOpen')
    this.$event.$off('childrensChangeOpen')
    this.$event.$off('scrollTo0')
    this.$event.$off('changeModel')
    this.$event.$off('initMVPData')
    this.$event.$off('pageBindTable')
    this.$event.$off('processBindPage')
  }
}
</script>

<style lang="less" scoped>
  .function__mvp{
    position: fixed;
    left: 0;
    z-index: 66;
    top: 0;
    visibility: visible;
    transition: top .2s ease-in;
  }
  .childrens_mvp{
    height: calc(100vh - 176px);
    overflow: auto;
    display: flex;
    flex-direction: column;
    user-select: none;
    .head{
      padding-top: 48px;
      height: 80px;
      background: #fff;
      box-shadow: 2px 2px 2px 0px rgba(0, 0, 0, 0.15);
      flex-shrink: 0;
      .fold-btns{
        i{
          border: 1px solid #E6E6E6;
          line-height: 32px;
          height: 32px;
          width: 20px;
          border-radius: 0 4px 4px 0;
        }
        button{
          margin-left: 4px;
        }
      }
    }
    .cont{
      flex-grow: 1;
      overflow: auto;
      margin-top: 9px;
      position: relative;
      .scroll{
        width: max-content;
        &>div::after{
          display: block;
          clear: both;
          content: '';
        }
      }
      .spin{
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba(247, 247, 247, 0.8);
      }
    }
    .empty{
      margin: auto;
    }
  }
  .ant-spin{
    position: absolute;
    left: 0;
    right: 0;
  }
</style>
